import { Stack } from "@mui/material";
import MyBloodPressureScreen from ".";
import type { BloodPressureDataPoint } from "./BloodPressureChart";
import { WellnessScoreStatus } from "../../Common/types";

const sampleChartData: BloodPressureDataPoint[] = [
  { date: "20/01", systolic: 132, diastolic: 80, fullDate: "20.01.2025" },
  { date: "02/04", systolic: 127, diastolic: 76, fullDate: "02.04.2025" },
  { date: "04/04", systolic: 125, diastolic: 78, fullDate: "04.04.2025" },
  { date: "12/05", systolic: 128, diastolic: 79, fullDate: "12.05.2025" },
  {
    date: "20/08",
    systolic: 127,
    diastolic: 76,
    fullDate: "20.08.2025",
    isSelected: true,
  },
];

export default function MyBloodPressureScreenExamples() {
  return (
    <Stack gap={4} width="100%">
      <MyBloodPressureScreen
        chartData={sampleChartData}
        status={WellnessScoreStatus.Healthy}
        lastUpdated="2025-02-23T00:00:00Z"
      />
    </Stack>
  );
}
